<section id="inicio" class="hero-carousel-section">
  <div id="heroCarousel" class="carousel slide carousel-fade">
    <!-- Único carousel-inner com apenas imagens reais -->
    <div class="carousel-inner">
      <!-- Enquanto carrega, mostra a primeira imagem local como placeholder -->
      @if (isLoading) {
        <div class="carousel-item active">
          <div
            class="hero-bg"
            style="background-image: url(&quot;assets/image/fundo.png&quot;)"
          ></div>
        </div>
      }

      <!-- Imagens da API (somente quando terminou de carregar) -->
      @if (!isLoading) {
        @for (image of carouselImages; track image; let i = $index) {
          <div
            class="carousel-item"
            [class.active]="i === 0"
            [attr.data-image-id]="image.id"
            >
            <div
              class="hero-bg"
            [style.background-image]="
              'url(' + getImageUrl(image.imagePath) + ')'
            "
              [attr.aria-label]="image.title"
            ></div>
          </div>
        }
      }
    </div>
  </div>

  <div class="hero-content">
    <div class="container text-white text-center">
      <h1
        class="display-5 fw-bold mb-3"
        style="
          font-size: clamp(1.75rem, 4vw, 2.75rem);
          text-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
        "
        >
        Sismet - Sistema de Monitoramento Meteorológico Cooxupé
      </h1>
      <p
        class="lead fw-semibold mb-4"
        style="
          font-size: clamp(1rem, 2vw, 1.25rem);
          text-shadow: 0 1px 10px rgba(0, 0, 0, 0.3);
          max-width: 700px;
          margin-inline: auto;
        "
        >
        Monitoramento climático em tempo real para gestão agrícola inteligente
      </p>
    </div>
  </div>
</section>
